<script setup>
    import { ref, onMounted, onUnmounted, watch } from 'vue';
    import api from '../../lib/serverApi';
    import utils from '../../lib/utils';
    import Dialog from 'primevue/dialog';
    import HistoryData from '../HistoryData.vue';

    const props = defineProps(['config']);
    const lastValue = ref({
        value: '------',
        status: '',
        moment: ''
    });
    const historyDialogVisible = ref(false);
    const hisoryDialogMaximized = ref(false);


    let updateTimer = null;

    function updateData() {
        api.getEntitieValues([props.config.entitieId])
        .then(data => {
            lastValue.value.status = data[0].status;
            lastValue.value.moment = utils.timeToString(data[0].moment);
            lastValue.value.value = data[0].status === 'GOOD' ? data[0].value : '------';
            updateTimer = setTimeout(updateData, props.config.updateIterval);
        })
        .catch(error => {
            lastValue.value.value = 'ERROR';
            lastValue.value.status = error.messag;
            lastValue.value.moment = '------';
        })
    }

    onMounted(() => {
        updateData();
    });

    onUnmounted(() => {
        if (updateTimer) clearTimeout(updateTimer);
    });

    watch(props, updateData);
</script>

<template>
    <div class="card my-2 mx-2 py-4 px-4">
        <div class="flex justify-content-between mb-3">
            <span class="block text-500 font-medium mr-3">{{ config.caption }}</span>
            <i class="pi pi-chart-line text-blue-500 text-xl" @click="historyDialogVisible = true"></i>
        </div>
        <div class="flex justify-content-center">
            <span class="mr-1 text-900 text-xl">{{ config.prefix }}</span>
            <div class="text-900 font-medium text-xl">{{ lastValue.value }}</div>
            <span class="ml-1 text-900 text-xl">{{ config.postfix }}</span>
        </div>
        <div v-if="config.showMoment" class="pt-3 text-500 text-sm text-center">{{ lastValue.moment }}</div>
    </div>

    <Dialog v-model:visible="historyDialogVisible"
        modal
        maximizable
        :header="config.caption"
        :style="{ width: '80rem' }"
        @maximize="hisoryDialogMaximized = true"
        @unmaximize="hisoryDialogMaximized = false"
    >
        <div class="h-full">
            <HistoryData
                :entitieId="config.entitieId"
                :maximized="hisoryDialogMaximized"
            />
        </div>
    </Dialog>

</template>
